import React from 'react';

import { Loader } from '@klarna/bubble-ui';

/** Fixes vertical placement issue with bubble-ui's Loader icon when used with Alert component */
const LoaderIcon = props => <Loader {...props} />;

export default LoaderIcon;
